import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useOrganizationService from '@/services/OrganizationService';

type Props = SetupProps<typeof OrganizationUsageSetupService.props>

export default class OrganizationUsageSetupService extends BaseSetupService<Props> {
	static readonly props = {
		display: {
			type: Array as PropType<('hero' | 'fusion' | 'roles' | 'tags' | 'all-clear')[]>,
			default: () => ['hero', 'roles', 'tags', 'fusion'],
		},
	};


	constructor (props?: Props) {
		super(props);
	}


	openOrganizationReleaseNoteModal () {
		useOrganizationService().showReleaseNoteModalAsync();
	}

	openOrganizationFusionRequest () {
		useOrganizationService().createOrganizationFusionRequestAsync();
	}
}
